(function () {
    let clearTasksTimeout = null;
    const clearTasksAfterMs = 5 * 1000;

    $(document).on('click', '.js-admin-tasks-modal-button', function (e) {
        const $modal = $('.admin-tasks-modal');
        $modal.toggleClass("hidden")
        e.preventDefault();

        if (clearTasksTimeout) {
            clearTimeout(clearTasksTimeout)
        }

        const clearTasksUrl= $modal.data("clear-tasks-url")
        if (!$modal.hasClass("hidden") && clearTasksUrl) {
            clearTasksTimeout = setTimeout(function () {
                $.ajax({url: clearTasksUrl, method: "POST"})
                $modal.find(".--new").removeClass("--new")
            }, clearTasksAfterMs)
        }
    });
}());


// WEBPACK FOOTER //
// ./weekly/static/js/admin_tasks.js